<template>
    <div class="chartContainer text-center">
        <h2 class="h3">Lightning</h2>
        <Doughnut :options="chartOptions" :data="chartData()" />
        <h3 class="h4">{{ value }} strikes</h3>
    </div>
</template>
  
<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Tooltip, Legend, ArcElement } from 'chart.js'

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
    name: 'LightningChart',
    props: ['value'],
    components: { Doughnut },
    computed: {
        dataSetData() {
            let valueArc = this.value;
            let remainderArc = this.range - valueArc;
            return [(valueArc/this.range),(remainderArc/this.range)]
        },
        arcColor() {
            if (this.value >= 0 && this.value < 4) {
                return '#0dcaf0'; // Light Blue for calm to light breeze
            } else if (this.value >= 4 && this.value < 8) {
                return '#198754'; // Green for moderate breeze
            } else if (this.value >= 8 && this.value < 16) {
                return '#f0dea5'; // Light Yellow for fresh breeze
            } else if (this.value >= 17 && this.value < 30) {
                return '#ffc107'; // Yellow for strong breeze to near gale
            } else if (this.value >= 30 && this.value < 47) {
                return '#fd7e14'; // Orange for gale to strong gale
            } else if (this.value >= 47) {
                return '#dc3545'; // Dark Red for storm and above
            }
            return '#198754'; // Default color, if needed
        }
    },
    methods: {
        chartData() {
            return {
                labels: ['Lightning strikes'],
                datasets: [{
                    data: this.dataSetData,
                    label: 'Lightning strikes',
                    backgroundColor: [this.arcColor, "#2b3035"]
                }]
            }
        }
    },
    data() {
        return {
            range: 100,
            chartOptions: {
                rotation: 270,
                cutout: '60%',
                circumference: 180,
                responsive: true,
                aspectRatio:2,
                layout: {
                    autoPadding: false,
                    padding:0
                },
                plugins: {
                    legend: {
                        display: false
                    },
                    tooltip: {
                        enabled: false
                    }
                },

            },
        }
    }
}
</script>